import styled from 'styled-components'
import { fontSize, fontWeight } from "buoy-theme"
import { responsive } from "../styledHelpers"
// 4851-todo: update responsive helper

// common component for error messages
// width can optionally be specified via props

const Error = styled.div`
  ${fontSize("bodyMain")};
  font-weight: ${fontWeight.light};
  ${props => props.width && `width: ${props.width};`}
  border-radius: 4px;
  text-align: center;
  padding: 5px;
  background-color: rgba(221, 28, 26,0.1);
  color: #DD1C1A;
  ${responsive("margin-bottom", "0", "18px")};
`

export { Error as default }


// WEBPACK FOOTER //
// ./assets/common/components/Error.js